module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAQpJREFUSEvdlX2NwkAQxecpAClI4FUBEnBwnAMk9BSABBTsVAISOAc4eGRIQ3rQpSxJA8f8tcmb7S9vPrawkQMjf99eC3D3nZk1JOs+p0N63Llx4O5TM/sKUdISwCEgfYAr/Ujy5zrvBpBS2ptZQA6SZgCOcc4AunqctyRX3dw+BzIzkmxSSg2AXa5ErR4lXLv7WtK8qqr5w4AoF8lw0Btd/SlAyQi/H8DMotmbtuH3zOxJfhc7aAF/JiJDifGsiwExRR/Rg/NGD8R5g4tL1PZgKym2OhsAosmrYsD/78HYDuLhKhpTALEzILkYeuyWkmoAk6Hx6eqSfgEsSMYLcInX/jJLHORyR3dwAnmA9xkc89IyAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/image/home.png
// module id = yoE5
// module chunks = 1